
import {ISelectOption} from '@hakosalo/hakolib';
import axios from 'axios';
import _ from 'lodash';
import { defineComponent } from 'vue'
export default defineComponent({
	name: "CategoryCreation",
	components: {
	},
	props: ["editcategoryprop"],
	expose: ['addNewCategory'],
	data() { return {
		category: {
			id: null,
			name: '',
			roleId: null,
			orderIndex: null,
			published: false,
			parentCategoryId: null
		},
		categories: [] as ISelectOption<number>[]
	}},
	methods: {
		addNewCategory() {
			if(this.category.name.length < 2) {
				this.$alert.alert('Tarkista kentät', 'Tarkista, että nimi on vähintään 2 merkkiä.')
				return
			}
			console.log(this.category)
			axios.post('Guide/NewCategory', this.category).then(resp => {
				console.log(resp.data);
				this.$emit('new-category', this.category)
			})
		},
		saveCategory() {
			if(this.category.name.length < 2) {
				this.$alert.alert('Tarkista kentät', 'Tarkista, että nimi on vähintään 2 merkkiä.')
				return
			}
			axios.patch('Guide/EditCategory', this.category).then(resp => {
				console.log(resp.data);
				this.$emit('edit-category', this.category)
			})
			.catch(err => {
				console.log(err)
			})
		},
		getCategoriesFromDb() {
			axios.get('Guide/AllCategories').then(resp => {
				resp.data.forEach((parent: any) => {
					let topCategory = {
						text: parent.name,
						value: parent.id,
						children: []
					} as ISelectOption<number>
					if(parent.children) {
						parent.children.forEach((child: any) => {
							let option = {
								value: child.id,
								text: child.name
							} as ISelectOption<number>
							topCategory.children?.push(option)
						})
					}
					this.categories.push(topCategory);
				})
			})
		},
		setCategoryFromProp() {
			if(this.editcategoryprop !== null) {
				// this.category.id = this.editcategoryprop.id;
				// this.category.name = this.editcategoryprop.name;
				// this.category.parentCategoryId = this.editcategory
				this.category = _.cloneDeep(this.editcategoryprop);
			}
		}
	},
	computed: {
		cCategories(): any {
			return this.categories.filter(x => x.value !== this.category.id);
		}
	},
	mounted() {
		this.getCategoriesFromDb();
		this.setCategoryFromProp();
	}
})
